module.exports = __webpack_public_path__ + "img/list_Character_sq_03.e3da5ed9.jpeg";